import React from "react";
import styles from "../css/secondary-button-v2.module.css";

export const SecondaryButtonV2 = ({
  className = "",
  size = "default",
  ...props
}) => {
  return (
    <button
      className={`${styles.button} ${styles.buttonSecondary} ${styles.buttonDefault} ${className}`}
      {...props}
    />
  );
};
